<template lang="pug">
  include /mixins
  +b.LABEL.checkout__label(:for='id')
    +e.SPAN.req {{ inputLabel }}
    +e.SPAN.req(v-if='isRequired') *
</template>

<script>
export default {
  name: 'CustomStaticLabel',

  props: {
    id: {
      type: String,
      required: false,
    },
    inputLabel: {
      type: String,
    },
    additionalLabel: {
      type: String,
    },
    isRequired: {
      type: Boolean,
    },
    hint: {
      type: String,
    },
  },
}
</script>
